import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import client from '../lib/feathers';

// Dashboard "Needs Review" panel — one glance at how many items are waiting in
// each admin review queue, so you know when there's cleanup to do without opening
// every report. Counts come from admin/review-queue-summary (one call).
export default function ReviewQueuePanel() {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    client.service('admin/review-queue-summary').find()
      .then(setData)
      .catch(() => setFailed(true));
  }, []);

  if (failed || !data) return null;
  const queues = data.queues || [];

  return (
    <div className="bg-white shadow rounded-lg p-4 my-5">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-base font-semibold text-gray-900">Needs Review</h3>
        <span className="text-sm text-gray-500">
          {data.total} item{data.total === 1 ? '' : 's'} waiting
        </span>
      </div>
      <ul className="divide-y divide-gray-100">
        {queues.map((q) => {
          const to = q.href.replace('./', '/admin/');
          const has = typeof q.count === 'number' && q.count > 0;
          return (
            <li key={q.key}>
              <NavLink
                to={to}
                className="flex items-center justify-between py-2 px-2 -mx-2 text-sm rounded hover:bg-gray-50"
              >
                <span className={has ? 'text-gray-900 font-medium' : 'text-gray-500'}>{q.label}</span>
                {q.count === null ? (
                  <span className="text-gray-300 text-xs">—</span>
                ) : (
                  <span className={`tabular-nums text-xs px-2 py-0.5 rounded-full ${has ? 'bg-primary text-white' : 'text-gray-400'}`}>
                    {q.count}
                  </span>
                )}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
